import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { NavService } from "../../../_services/NavService.service";
import { appService } from '../../../_services/app.service';
import { CommonService } from '../../../_services/common.service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../helpers';
import { ITableModel } from '../../../shared/components/table/model/tableModel';
import { MobileDetectionService } from '../../../shared/services/mobile-detection.service';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { OrdersService } from '../../../shared/services/orders/orders.service';



@Component({
  selector: 'app-shipment-audit-trail',
  templateUrl: './shipment-audit-trail.component.html',
  styleUrls: ['./shipment-audit-trail.component.scss']
})
export class ShipmentAuditTrailComponent implements OnInit {

  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  noOfPages: number = 15;
  totalCount: number = 0;
  TenantId: any;
  CompanyId: any;
  isListApiCalled: boolean;
  userId: any;
  reportHeader: any = [];
  payload: any = {};
  customerId: any;
  viewType: any;
  isDetailsPageShow: any;
  totalOrderCount: any;
  StockDetails: any = [];
  tableDetails:any= {
    emptyDataMSg: "No Records Found",
    data: [],
    columnDetails: [],
    actionList: [],
    isColumnNameShow: true,
  };
  hostUrl: any = environment.apiUrl;
  @Input() SelectedId: any;
  @Output() onCloseBtnClick = new EventEmitter<any>();
  
  WarehouseName:any;

  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private translate: TranslateService,
    private commonService: CommonService,
    private _navService: NavService,
    private service: TranslateConfigService,
    private mobileDetectionService: MobileDetectionService,
    private modalService: NgbModal,
    private orderService: OrdersService
  ) { }

  ngOnInit() {
    this.TenantId = JSON.parse(
    this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    this.GetAuditTrailList();
  }

  ngOnChanges(changes: SimpleChanges) {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
      if (changes['SelectedId']) {
        this.SelectedId = changes['SelectedId'].currentValue;
        if (this.SelectedId) {
          this.GetAuditTrailList();
        }
      }
  }

  ngOnDestroy() {
    localStorage.removeItem('perPage');
  }

  GetAuditTrailList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    isFilter = false
  ) {
    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);
    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;
    this.payload.SearchValue = searchValue;
    this.payload.CompanyId = this.CompanyId;
    this.payload.Id = this.SelectedId || null;
    this.payload.UserId = this.userId || null;
    this._appService.Post("OperationalReport", "GetShipmentAuditTrail", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].Count;
      
        let i = 0;
        response.forEach((value, prop, obj) => {
          if (i == 0) {
            delete value["Count"];
            this.reportHeader = Object.getOwnPropertyNames(value);
          }
          i++;
        });

        this.tableDetails.columnDetails = [];
        for (const item of this.reportHeader) {
          var obj: any = {};
          obj.columnName = item;
          obj.dataFieldName = item;
          this.tableDetails.columnDetails.push(obj);
        }
      }
      this.assignTableFields(pageNo, perPage, response)
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(
          this.translate.instant("User.ErrorMessage"),
          "error"
        );
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails,
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.GetAuditTrailList(this.searchValue, pageNo - 1, this.filterObj, storedPerPage);
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.noOfPages = noOfPages
    this.GetAuditTrailList(this.searchValue, 0, this.filterObj, noOfPages);
  }

  findObjectOfTheField(dataField, dropdownList, type) {
    type.dropdownList = dropdownList;
    type.isSearch = false;
    if (type.dataField) {
      type.isReadOnly = false
    }
  }

  BackTofunction() {
    this.onCloseBtnClick.emit()
  }
  
  onFilterClick() {
    console.log();
  }

  callParentList(event:any){
    this.WarehouseName = event;
    this.GetAuditTrailList();
  }
}
